<!--eslint-disable-->
<template>

    <div id="app">
        <router-view/>
    </div>

</template>
<!--eslint-disable-->
<script>



    export default {
        name: "App",
        components: {

            // ...

        },
        created() {

            // ...

        },
        mounted() {

            // ...

        },
        data() {
            return {

                // ...

            }
        },
        computed: {

            // ...

        },
        methods: {

            // ...

        }
    };

</script>
<!--eslint-disable-->
<style lang="scss">

    // ...

</style>
